import styled from 'styled-components';

export const Toggler = styled.label`
  height: 34px;
  width: 60px;
  position: relative;
  display: inline-block;
`;

export const Switch = styled.input.attrs({
  type: 'checkbox'
})`
  opacity: 0;
  width: 0;
  height: 0;


  &:checked + span:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }
`;

export const Span = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props => props.theme === 'dark' ? '#eead2d' : '#17116E'};
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 34px;

  &::before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 50%;
  }
`;


